import { MouvementForm } from "@features/stock";
import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const createSearchSchema = z.object({
  type: z.enum(["entree", "sortie", "transfert", "ajustement"]).optional(),
});

export const Route = createFileRoute("/_app/stock/mouvements/create")({
  validateSearch: createSearchSchema,
  staticData: {
    title: "Nouveau Mouvement",
    showInBreadcrumb: true,
    parent: "/_app/stock/mouvements",
  },
  loader: requirePermission("stock.movements.create"),
  component: RouteComponent,
});

function RouteComponent() {
  const { type } = Route.useSearch();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouveau Mouvement</h1>
      </div>
      <div className="max-w-2xl">
        <MouvementForm defaultType={type} />
      </div>
    </div>
  );
}
